/** Keeps one readiness-edge load alive until it settles, resets, or unmounts. */
export class AppointmentDraftLoadLifecycle {
  private generation = 0;
  private started = false;

  start<T>(
    hasReadyDraft: boolean,
    load: () => Promise<T>,
    onLoaded: (value: T) => void,
    onFailed: (error: unknown) => void,
  ): void {
    if (!hasReadyDraft || this.started) return;
    this.started = true;
    const generation = this.generation;
    void load().then(
      (value) => {
        if (generation === this.generation) onLoaded(value);
      },
      (error: unknown) => {
        if (generation === this.generation) onFailed(error);
      },
    );
  }

  reset(): void {
    this.generation += 1;
    this.started = false;
  }

  dispose(): void {
    this.generation += 1;
  }
}
